import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BackendLoyaltyService } from '../../services/backend-loyalty.service';

import { RegisterAgentSuccess } from '../../actions/loyalty/actions-agent';
import * as AgentAction from '../../actions/loyalty/actions-agent';

import { IAgentModel } from '../../models/loyalty/IAgent.model';
import { select, Store } from '@ngrx/store';
import { getCustomerProfileState, getInfoForLoyaltyEloqua } from '../../reducers';
import { customerConfig, InitCustomerConfig } from '@uxdf/direct-shared-lib';
import { LoyaltyAlertService } from '../../services/LoyaltyAlertService';
import { EloquaLoyaltyService } from '../../services/eloqua-loyalty.service';
import * as CoreActions from '@uxdf/direct-shared-lib/src/lib/login/core.actions';
import { CustomerState as CustomerProfileState } from '../../../redux/models/loyalty/customer.state';
import { State as CustomerState } from '../../../redux/reducers/customer';

@Injectable()
export class EffectsAgent {
  bindAgent$: Observable<any> = createEffect(() => {
    return this.actions$.pipe(
      ofType<AgentAction.BindAgent>(AgentAction.BIND_AGENT),
      switchMap(request =>
        this.backendLoyaltyService
          .bindAgent(request['payload'].number, request['payload'].password, request['payload'].contactId)
          .pipe(
            withLatestFrom(this.store.pipe(select(getInfoForLoyaltyEloqua))),
            map(([response, eloquaInfo]: [IAgentModel, any]) => {
              const eloquaData = this.eloquaService.getLoyaltyEloquaData(eloquaInfo, response.data.number, true);

              this.eloquaService.postLoyaltyEloqua(eloquaData);
              return new AgentAction.BindAgentSuccess(response);

            }),
            catchError(error => {
              if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
                return of(new CoreActions.DirectUserRoleHasBeenChanged());
              } else {
                this.loyaltyAlertService.catchAgentError(error);
                return this.bindAgent$;
              }
            })
          )
      )
    );
  })

  approveSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType<AgentAction.BindAgentSuccess>(AgentAction.BIND_AGENT_SUCCESS),
      filter((action: AgentAction.BindAgentSuccess) => Boolean(action.payload.data && action.payload.data.number)),
      switchMap(() => of(new InitCustomerConfig()))
    )
  });

  /* eslint-disable */
  registerAgent$: Observable<{} | RegisterAgentSuccess> = createEffect((): any => {
    return this.actions$.pipe(
      ofType<AgentAction.RegisterAgent>(AgentAction.REGISTER_AGENT),
      withLatestFrom(this.store.pipe(select(customerConfig)), this.store.pipe(select(getCustomerProfileState))),
      switchMap(([, customer, customerProfileConfig]: [any, CustomerState, CustomerProfileState]) =>
        this.backendLoyaltyService.registerAgent(
          this.backendLoyaltyService.prepareDataForRegisterAgent({
            customerConfig: customer.customerConfig,
            customerProfileConfig
          })
        )
      ),
      withLatestFrom(this.store.pipe(select(getInfoForLoyaltyEloqua))),
      map(([response, eloquaInfo]: [IAgentModel, any]) => {
        if (!response.data || response.code !== 200) {
          throw new Error('Loyalty request error');
        }
        this.store.dispatch(new InitCustomerConfig());
        const eloquaData = this.eloquaService.getLoyaltyEloquaData(eloquaInfo, response.data.number, false);
        this.eloquaService.postLoyaltyEloqua(eloquaData);

        return new AgentAction.RegisterAgentSuccess(response);

      }),
      catchError(error => {
        console.warn('error: ', error);
        if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
          return of(new CoreActions.DirectUserRoleHasBeenChanged());
        } else {
          this.loyaltyAlertService.catchAgentError(error);
          return this.registerAgent$;
        }
      })
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly backendLoyaltyService: BackendLoyaltyService,
    private readonly store: Store<any>,
    private readonly loyaltyAlertService: LoyaltyAlertService,
    private readonly eloquaService: EloquaLoyaltyService
  ) { }
}
